const base = process.env.PUBLIC_URL || "";

export function asset(path) {
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}

export const ASSETS = {
  heroVideo: asset("/assets/video/splash004.mp4"),
  heroPoster: asset("/assets/video/3.png"),
  heroFallback: asset("/assets/video/3.png"),
  pillarVideos: [
    asset("/assets/video/v1.mp4"),
    asset("/assets/video/v2.mp4"),
    asset("/assets/video/v3.mp4"),
    asset("/assets/video/v4.mp4"),
  ],
  howItWorks: [
    asset("/assets/home/3.howitworks__1.png"),
    asset("/assets/home/3.howitworks__2.png"),
    asset("/assets/home/3.howitworks__3.png"),
  ],
  ipadFrame: asset("/assets/home/frame_001.png"),
  demoPoster: asset("/assets/home/sh_001.png"),
  demoVideo: asset("/assets/home/splash_001.mp4"),
  lifestyle: asset("/assets/1/woman_2.jpg"),
  ctaBg: asset("/assets/1/footer_bgpic.jpg"),
  partners: [
    { src: asset("/assets/partners/labmoment.png"), alt: "Lab Moment", className: "h-11" },
    { src: asset("/assets/partners/galeno.png"), alt: "Galeno", className: "h-16" },
    { src: asset("/assets/partners/tellmeGen.png"), alt: "TellmeGen", className: "h-11" },
    { src: asset("/assets/partners/echevarne-300x225.png"), alt: "Echevarne", className: "h-36" },
    { src: asset("/assets/partners/AMBIOTA_Logo.png"), alt: "AMBIOTA", className: "h-7" },
  ],
};
